export default {
  computed: {
    token() {
      return this.$store.getters.token
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    workspaceAndVersion() {
      return { workspace: this.workspace, version: this.version }
    },
    currentWs() {
      return this.workspaceAndVersion.workspace && this.$store.getters.activeWorkspaceList
        ? this.$store.getters.activeWorkspaceList.filter((v) => v.id === this.workspaceAndVersion.workspace)
        : null
    },

    currentWsItem() {
      if (this.currentWs && this.currentWs[0]) {
        return this.currentWs[0]
      }
      return null
    },

    isPublicWs() {
      return this.currentWsItem ? this.currentWsItem.public : false
    },
    canEditWs() {
      return this.currentWsItem ? this.currentWsItem.can_edit : false
    },

    /**
     * Общее WS или нет
     */
    sharedWs() {
      return this.currentWsItem ? this.currentWsItem.shared : false
    },

    /**
     * Пользователь-владелец выбранного ws
     */
    currentWsUserId() {
      return this.currentWsItem ? this.currentWsItem.user : null
    },

    /**
     * Проверяет является ли текущий пользователь владельцем выбранного рабочего пространства
     * @returns
     */
    isUserWsOwner() {
      if (!this.currentWsUserId || !this.$store.getters.userId) {
        return false
      }
      return this.currentWsUserId === this.$store.getters.userId
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js